<fc-progress-bar currentStep="5"></fc-progress-bar>
<div #container *ngIf="activeSite" class="container">
  <header class="page-header">
    <div class="fc-back-link" [routerLink]="['/site', activeSite.id, 'eligibility-questions']">
      <fa-icon [icon]="['far', 'arrow-left']" class="gray"></fa-icon>
      <span>Back</span>
    </div>
    <div class="header-text">You're just steps away from completing your Carbon Offset Site!</div>
    <mat-divider></mat-divider>
  </header>

  <div class="buyer-header-bar">
    <ng-container *ngIf="activeSite && activeSite.cohort.buyer">
      <img
        [alt]="activeSite.cohort.buyer.name"
        [src]="getOpenAssetURL(activeSite.cohort.buyer.shortName, 'logo.svg')" />
    </ng-container>
    <div class="total-annual-value-container">
      Estimated Annual Revenue:
      <div class="valuation">
        {{ valuePerYear }}
      </div>
    </div>
  </div>

  <div class="main-container">
    <main class="step-info">
      <div class="header">Property Information & Supporting Documentation</div>
      <mat-divider></mat-divider>
      <form [formGroup]="submitInfoForm" class="info-panel" fcFormUnloadWarning>
        <div class="info-row">
          <div class="instruction-number">1</div>
          <div class="instruction-text">
            Please create a name for this Carbon Offset Site. (50 characters max)
            <span aria-hidden="true" class="required">*</span>
          </div>
        </div>
        <div class="info-row">
          <div class="instruction-number">&nbsp;</div>
          <div class="instruction-data">
            <mat-form-field class="full-width">
              <mat-label class="data-header">Give Your Site a Name</mat-label>
              <input formControlName="siteName" id="siteName" matInput maxlength="50" required type="text" />
            </mat-form-field>
            <div *ngIf="submitInfoForm.controls.siteName.invalid" class="validation-error">
              Your site name can only contains letters, numbers, and these characters: - + ( ) . _
            </div>
          </div>
        </div>
        <div class="info-row">
          <div class="instruction-number">2</div>
          <div class="deed-names">
            <div class="instruction-text">
              Are any of the included sites owned wholly or in part by any other individuals or organizations other than
              yourself?
              <span aria-hidden="true" class="required">*</span>
            </div>
            <mat-radio-group (change)="otherNameClick($event)" [value]="showNameList">
              <mat-radio-button [value]="false">No</mat-radio-button>
              <mat-radio-button [value]="true">Yes</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div *ngIf="showNameList" class="info-row">
          <div class="instruction-number">&nbsp;</div>
          <div class="instruction-data">
            <mat-form-field class="w-100-1">
              <mat-label class="data-header">
                Please enter the other names found on all deeds, including any entity tax identification for all
                entities listed on any deed
              </mat-label>
              <input formControlName="ownerNames" id="ownerNames" matInput type="text" />
            </mat-form-field>
          </div>
        </div>
        <div class="info-row">
          <div class="instruction-number">3</div>
          <div class="deed-names">
            <div class="instruction-text">
              Were you assisted by a forestry firm in signing up for LandYield?
              <span aria-hidden="true" class="required">*</span>
            </div>
            <mat-radio-group (change)="forestryFirmClick($event)" [value]="showForestryFirm">
              <mat-radio-button [value]="false">No</mat-radio-button>
              <mat-radio-button [value]="true">Yes</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div *ngIf="showForestryFirm" class="info-row">
          <div class="instruction-number">&nbsp;</div>
          <div class="instruction-data">
            <mat-form-field class="full-width">
              <mat-label class="data-header">
                Please enter the name for any firms that assisted you in setting up your site with LandYield
              </mat-label>
              <input formControlName="forestryFirm" id="forestryFirm" matInput type="text" />
            </mat-form-field>
          </div>
        </div>
        <div class="info-row">
          <div class="instruction-number">4</div>
          <div class="deed-names">
            <div class="instruction-text">
              Is there a mortgage or deed of trust on the property?
              <span aria-hidden="true" class="required">*</span>
            </div>
            <mat-radio-group (change)="mortgageClick($event)" [value]="showMortgage">
              <mat-radio-button [value]="false">No</mat-radio-button>
              <mat-radio-button [value]="true">Yes</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div *ngIf="showMortgage" class="info-row">
          <div class="instruction-number">&nbsp;</div>
          <div class="instruction-data">
            <div class="data-header">
              Please provide the following information about all mortgages for this property:
              <br />
              Name of Lender
              <br />
              Approximate Balance
              <br />
              Maturity Date
              <br />
              Recording Information(Book/Page or Instrument Number):
              <span aria-hidden="true" class="required">*</span>
            </div>
            <mat-form-field class="full-width">
              <textarea formControlName="mortgageInformation" id="mortgageInformation" matInput rows="3"></textarea>
            </mat-form-field>
          </div>
        </div>
        <div class="info-row">
          <div class="instruction-number">5</div>
          <div class="instruction-text">
            <div>
              To help us confirm you have the legal right to submit this property/properties, you provide a copy of all
              page of current deeds and tax bills for all properties. If your deed or tax bill does not contain the
              parcel number for the property, you also provide additional documentation which specifies the parcel
              number.
            </div>
            <div *ngIf="showNameList">
              Additionally, please provide documentation that shows you are authorized to enter a legal agreement on
              behalf of any other owners, whether individuals or entities.
            </div>
            <div>
              <strong>
                Please provide as many of the below documents are you have. Any lack of documents could delay your
                acceptance into the carbon program:
              </strong>
            </div>
            <div class="doc-list">
              Deed, Survey of Property, Title Report/Insurance, Tax Bill
              <fa-icon
                #tooltip5="matTooltip"
                (click)="tooltip5.toggle()"
                [icon]="['far', 'circle-info']"
                class="blue"
                matTooltip="Before approving your carbon offset site, we need to verify your ownership of the related land. Uploading as many of these documents as possible will assist us in this review and speed the approval process of your site."
                matTooltipClass="fc-tooltip"
                matTooltipPosition="right"></fa-icon>
            </div>
          </div>
        </div>
        <div class="info-row doc-row">
          <div class="instruction-number">&nbsp;</div>
          <div class="instruction-data">
            <div class="required-doc-section">
              <div class="doc-requires">
                <fa-icon
                  [icon]="[hasDocType(this.deedTypeId) ? 'fas' : 'far', 'circle-check']"
                  [ngClass]="hasDocType(this.deedTypeId) ? 'green' : 'gray'"></fa-icon>
                <span class="doc-type">Deed</span>
              </div>
              <div class="doc-requires">
                <fa-icon
                  [icon]="[hasDocType(this.taxTypeId) ? 'fas' : 'far', 'circle-check']"
                  [ngClass]="hasDocType(this.taxTypeId) ? 'green' : 'gray'"></fa-icon>
                <span class="doc-type">Tax Bill</span>
              </div>
              <div
                #tooltip6="matTooltip"
                (click)="tooltip6.toggle()"
                *ngIf="!this.hasDocType(this.taxTypeId) || !this.hasDocType(this.deedTypeId)"
                class="no-documents-tooltip fc-link"
                matTooltip="If you do not have these documents for upload now, please save your site and return when you have the document(s) ready for upload. If you have questions or require assistance, please contact LandYield using the “Contact Us” information on this site."
                matTooltipClass="fc-tooltip"
                matTooltipPosition="left">
                <fa-icon [icon]="['far', 'circle-info']" class="blue"></fa-icon>
                <span>Don't have These Documents?</span>
              </div>
            </div>
            <fc-site-doc-list [activeSite]="activeSite"></fc-site-doc-list>
          </div>
        </div>
      </form>
    </main>

    <div class="button-area">
      <button (click)="advance(true)" color="primary" data-cy="button-back" mat-stroked-button>Save For Later</button>
      <button
        (click)="advance(false)"
        [class.disabled]="!formIsValid()"
        [disabled]="!formIsValid()"
        class="button-next"
        color="primary"
        data-cy="button-primary"
        mat-raised-button>
        <span>Next</span>
      </button>
    </div>
  </div>
</div>
